import { SettingsRadioItem } from 'modules/settingsContainer/SettingsRadio/types';

export const getActiveRadioValue: <ValueType extends string | number>(
  options: SettingsRadioItem<ValueType>[],
  value: SettingsRadioItem<ValueType>['value'],
) => SettingsRadioItem<ValueType> = (options, value) => options.find((option) => option.value === value) || options[0];
